import React from 'react';
import PropTypes from 'prop-types';

import './layout.css';
import classes from './layout.module.css';

const Layout = ({ children }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}
  >
    <div
      className={classes.Layout}
      style={{
        width: '100%'
      }}
    >
      {children}
    </div>
  </div>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
